import React, { useState } from "react";

const ContactFormThree = () => {
  const [inputs, setInputs] = useState({});
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs({ ...inputs, [name]: value });
  };

  const handleSend = (e) => {
    e.preventDefault()
    var texto = `Hola, mi nombre es ${inputs.name} y me interesa ponerme en contacto con ustedes, mi correo es ${inputs.email}, mi mensaje hacia ustedes es ${inputs.message}`;
    window.open(`https://api.whatsapp.com/send?phone=5216674922953&text=${texto}`,'_blank');
  }

  return (
    <form
      name="contact-form"
      id="contact-form"
      className="app-form"
      onSubmit={handleSend}
    >
      <div className="messages"></div>
      <div className="row">
        <div
          className="col-md-6 col-sm-6"
          data-aos={"fade-up"}
          data-aos-delay={100}
          data-aos-duration={700}
        >
          <div className="form-floating">
            <input
              type="text"
              name="name"
              className="form-control"
              id="name"
              required="required"
              placeholder="Tu nombre"
              data-error="Tu nombre es requerido"
              value={inputs.name}
              onChange={handleInputChange}
            />
            <label htmlFor="name">Nombre</label>
            <div className="help-block with-errors mt-20"></div>
          </div>
        </div>
        <div
          className="col-md-6 col-sm-6"
          data-aos={"fade-up"}
          data-aos-delay={100}
          data-aos-duration={700}
        >
          <div className="form-floating">
            <input
              type="email"
              name="email"
              className="form-control"
              id="email"
              placeholder="Tu correo"
              required="required"
              data-error="Por favor ingresa un correo valido"
              value={inputs.email}
              onChange={handleInputChange}
            />
            <label htmlFor="email">Correo</label>
            <div className="help-block with-errors mt-20"></div>
          </div>
        </div>
      </div>
      <div
        className="form-floating"
        data-aos={"fade-up"}
        data-aos-delay={100}
        data-aos-duration={700}
      >
        <textarea
          name="message"
          className="form-control"
          id="message"
          rows="7"
          placeholder="Tu mensaje"
          required
          data-error="Por favor, dejanos un mensaje"
          value={inputs.message}
          onChange={handleInputChange}
        ></textarea>
        <label htmlFor="message">Mensaje</label>
        <div className="help-block with-errors mt-20"></div>
      </div>
      <div
        className="text-center"
        data-aos={"fade-up"}
        data-aos-delay={100}
        data-aos-duration={700}
      >
        <button
          type="submit"
          name="submit"
          className="btn btn-color btn-circle"
        >
          Enviar mensaje
        </button>
      </div>
    </form>
  );
};

export default ContactFormThree;
